export default __webpack_public_path__ + "static/media/logout-icon.0144795b.svg";